<template>
  <div id="app">
    <router-view v-if="isRouterAlive" ref="route"></router-view>
  </div>
</template>

<script>

import {area_list,shoppingCartlist,getUserInfo,InquiryBasketList} from "@/api/xunyou";
export default {
    name: "App",
    provide(){
      return {
        reload:this.reload
      }
    },
    data(){
      return {
        userInfo: JSON.parse(localStorage.getItem("userdata")) || { mallUser: {},},

        isRouterAlive:true
      }
    },
    created(){
      this.getprovinceList()  
       if (Boolean(localStorage.getItem("userdata"))) {
          this.checkUserInfo();
          if(this.userInfo.mallUser.username!=null||this.userInfo.mallUser.username!="" ){
          this.getshoppingCartlist();
          this.getInquiryBasketList()
        } 
       }
        
    },
    methods:{
      // 可刷新页面
      reload(){
        this.isRouterAlive = false
        this.$nextTick(()=>{
          this.isRouterAlive = true
        })
      },
       // 获取地址
       getprovinceList(){
           area_list()
               .then(res => {
               if (res.code == 0) {
                 this.$store.commit('getAddress',res.data)
               } else {
                   this.$message({
                     type: 'info',
                     message: res.msg
                   })
               }
               })
               .catch(err => {
               this.$message.error('获取地址失败，请稍后再试！')
               })
       },
      // 获取购物车
       getshoppingCartlist(){
           shoppingCartlist({uid:this.userInfo.mallUser.muid||''})
               .then(res => {
               if (res.length> 0) {
                 this.$store.commit('getCartList',res)
               }
            })
               .catch(err => {
               this.$message.error('购物车查询失败，请稍后再试！')
               })
       },
       //获取询价篮
    getInquiryBasketList(){
        
      InquiryBasketList({
        id:this.userInfo.mallUser.muid
      }).then((res)=>{
        
        if(res.success){
          let inquiryList = []
          res.data.shopList.forEach((item)=>{
            item.voList.forEach((voListItme)=>{
              inquiryList.push(voListItme)
              
            })
          })
          this.$store.commit('getInquiryList',inquiryList)
        }else{
          console.log(res)
          this.$message.error(res.errorMessage)
        }
      }).catch((err)=>{
        this.$message.error(err.errorMessage)
      })
    },
       //判断当前用户是否存在
       async checkUserInfo(){
        //  console.log(this.userInfo.mallUser);
         const res = await getUserInfo({username:this.userInfo.mallUser.username,muid:this.userInfo.mallUser.muid});
         console.log(res);
        //  console.log(res,'ressssss')
       }
    },
};
</script>

<style> 
html,
body {
    width: 100%;
    height: 100%;
    background: #fff;
    box-sizing: border-box;
    padding: 0px;
    margin: 0px;
}
#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    width: 100%;
    height: 100%;
}
.el-popover.el-popper.backTopBox{
    top: auto !important;
    bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue